import { render, staticRenderFns } from "./memberRank.vue?vue&type=template&id=61204778&scoped=true&"
import script from "./memberRank.vue?vue&type=script&lang=js&"
export * from "./memberRank.vue?vue&type=script&lang=js&"
import style0 from "./memberRank.vue?vue&type=style&index=0&id=61204778&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61204778",
  null
  
)

export default component.exports